import { useExportTrackNTraceExcelMutation } from "../../../redux/services/tagApiSlice";
import { useGetTrackNTraceTagQuery } from "../../../redux/services/trackntraceApiSlice";
import EnablementReport from "./EnablementReport"

const TNTEnablementReport = () => {
    return (
        <EnablementReport useReportQuery={useGetTrackNTraceTagQuery} useExportMutation={useExportTrackNTraceExcelMutation} />
    )
}

export default TNTEnablementReport;